var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGallery = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.277 3.598H3.27a.5.5 0 0 0-.5.5v3.228a.5.5 0 0 0 .5.5h4.006a.5.5 0 0 0 .5-.5V4.098a.5.5 0 0 0-.5-.5Zm0 6.576H3.27a.5.5 0 0 0-.5.5v3.228a.5.5 0 0 0 .5.5h4.006a.5.5 0 0 0 .5-.5v-3.228a.5.5 0 0 0-.5-.5Zm7.453-6.576h-4.007a.5.5 0 0 0-.5.5v3.228a.5.5 0 0 0 .5.5h4.006a.5.5 0 0 0 .5-.5V4.098a.5.5 0 0 0-.5-.5Zm0 6.576h-4.007a.5.5 0 0 0-.5.5v3.228a.5.5 0 0 0 .5.5h4.006a.5.5 0 0 0 .5-.5v-3.228a.5.5 0 0 0-.5-.5Z" }) }))); };
export default SvgGallery;
